import ApiService from 'app/services/ApiService';

export const COMMUNICATION_STATUS_SUCCESS = 'COMMUNICATION_STATUS_SUCCESS';
export const COMMUNICATION_STATUS_BEGIN = 'COMMUNICATION_STATUS_BEGIN';
export const COMMUNICATION_STATUS_FAILURE = 'COMMUNICATION_STATUS_FAILURE';
export const CLEAR_COMMUNICATION_STATUS = 'CLEAR_COMMUNICATION_STATUS';


export function fetchCommunicationStatus(id, params = {}) {
    return async dispatch => {
        dispatch(communicationStatusBegin());
        await ApiService.getCommunicationSummary(id, params)
            .then(
            result => {
                dispatch(communicationStatusSuccess(result));
                },
                error => {
                    dispatch(communicationStatusError());
                    // eslint-disable-next-line no-throw-literal
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}


export const communicationStatusBegin = () => ({
    type: COMMUNICATION_STATUS_BEGIN,
});
export const communicationStatusSuccess = data => ({
    type: COMMUNICATION_STATUS_SUCCESS,
    payload: { data }
})
export const communicationStatusError = () => ({
    type: COMMUNICATION_STATUS_FAILURE,
})
export const clearCommunicationStatus = () => ({
    type: CLEAR_COMMUNICATION_STATUS,
})
